import { tsValidateOptionalId } from '@nu-art/ts-common';
import { PermissionDBGroup } from '@nu-art/permissions-shared';
const Validator_ModifiableProps = {
    defaultInitialPermissions: {
        permissionGroupForNewRegistrants: tsValidateOptionalId,
        readAccessLevel: tsValidateOptionalId,
        writeAccessLevel: tsValidateOptionalId,
    }
};
const Validator_GeneratedProps = {};
export const DBDef_OrganizationPermission = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'organization-permissions',
    entityName: 'Organization Permission',
    frontend: {
        group: PermissionDBGroup,
        name: 'organization-permissions'
    },
    backend: {
        name: 'organization-permissions'
    },
};
//# sourceMappingURL=db-def.js.map